/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Profile } from './Profile';
import {
    ProfileFromJSON,
    ProfileFromJSONTyped,
    ProfileToJSON,
    ProfileToJSONTyped,
} from './Profile';

/**
 * 
 * @export
 * @interface Import
 */
export interface Import {
    /**
     * 
     * @type {string}
     * @memberof Import
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Import
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Import
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Import
     */
    href?: string;
    /**
     * 
     * @type {string}
     * @memberof Import
     */
    description?: string;
    /**
     * 
     * @type {Profile}
     * @memberof Import
     */
    profile?: Profile;
}

/**
 * Check if a given object implements the Import interface.
 */
export function instanceOfImport(value: object): value is Import {
    return true;
}

export function ImportFromJSON(json: any): Import {
    return ImportFromJSONTyped(json, false);
}

export function ImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Import {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'href': json['href'] == null ? undefined : json['href'],
        'description': json['description'] == null ? undefined : json['description'],
        'profile': json['profile'] == null ? undefined : ProfileFromJSON(json['profile']),
    };
}

export function ImportToJSON(json: any): Import {
    return ImportToJSONTyped(json, false);
}

export function ImportToJSONTyped(value?: Import | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'href': value['href'],
        'description': value['description'],
        'profile': ProfileToJSON(value['profile']),
    };
}

